import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { getAdminKey, clearAdminKey } from "@/lib/auth";

export default function AdminGuard({ children }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!getAdminKey()) {
      setStatus("invalid");
      return;
    }
    api.post("/auth/verify")
      .then(() => setStatus("ok"))
      .catch(() => {
        clearAdminKey();
        setStatus("invalid");
      });
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <p className="font-mono text-xs text-white/40">Verifying access…</p>
      </div>
    );
  }
  if (status === "invalid") return <Navigate to="/admin/login" replace />;
  return children;
}
